import styled from 'styled-components';
import { greenColor } from 'js/config/style';

export default styled.div`
  color: ${greenColor};
  margin-bottom: 0.5rem;
`;
